<template>
	<div
		:class="
			[
				$style['grid-column'],
				col > 0 ? $style[`grid-column--col-${col}`] : '',
				xs > 0 ? $style[`grid-column--col-xs-${xs}`] : '',
				sm > 0 ? $style[`grid-column--col-sm-${sm}`] : '',
				md > 0 ? $style[`grid-column--col-md-${md}`] : '',
				lg > 0 ? $style[`grid-column--col-lg-${lg}`] : '',
				xl > 0 ? $style[`grid-column--col-xl-${xl}`] : ''
			].filter(Boolean)
		"
	>
		<slot />
	</div>
</template>

<script>
const columns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
const inColumns = val => columns.indexOf(parseInt(val)) !== -1

export default {
	name: 'GridColumn',
	props: {
		col: {
			type: [String, Number],
			validator: inColumns,
			default: 12 // Changed from 0 to 12 for full width default
		},
		xs: {
			type: [String, Number],
			validator: inColumns,
			default: 0
		},
		sm: {
			type: [String, Number],
			validator: inColumns,
			default: 0
		},
		md: {
			type: [String, Number],
			validator: inColumns,
			default: 0
		},
		lg: {
			type: [String, Number],
			validator: inColumns,
			default: 0
		},
		xl: {
			type: [String, Number],
			validator: inColumns,
			default: 0
		}
	}
}
</script>

<style lang="scss" module>


	.grid-column {
		flex: 0 0 auto;
		width: 100%;
		max-width: 100%;
		padding: 0 $gutter * 1.25;
		box-sizing: border-box;
	}

	// Base column classes (explicit instead of @for loop)
	.grid-column--col-1 {
		flex: 0 0 8.3333%;
		max-width: 8.3333%;
		width: 8.3333%;
	}

	.grid-column--col-2 {
		flex: 0 0 16.6667%;
		max-width: 16.6667%;
		width: 16.6667%;
	}

	.grid-column--col-3 {
		flex: 0 0 25%;
		max-width: 25%;
		width: 25%;
	}

	.grid-column--col-4 {
		flex: 0 0 33.3333%;
		max-width: 33.3333%;
		width: 33.3333%;
	}

	.grid-column--col-5 {
		flex: 0 0 41.6667%;
		max-width: 41.6667%;
		width: 41.6667%;
	}

	.grid-column--col-6 {
		flex: 0 0 50%;
		max-width: 50%;
		width: 50%;
	}

	.grid-column--col-7 {
		flex: 0 0 58.3333%;
		max-width: 58.3333%;
		width: 58.3333%;
	}

	.grid-column--col-8 {
		flex: 0 0 66.6667%;
		max-width: 66.6667%;
		width: 66.6667%;
	}

	.grid-column--col-9 {
		flex: 0 0 75%;
		max-width: 75%;
		width: 75%;
	}

	.grid-column--col-10 {
		flex: 0 0 83.3333%;
		max-width: 83.3333%;
		width: 83.3333%;
	}

	.grid-column--col-11 {
		flex: 0 0 91.6667%;
		max-width: 91.6667%;
		width: 91.6667%;
	}

	.grid-column--col-12 {
		flex: 0 0 100%;
		max-width: 100%;
		width: 100%;
	}

	// XS breakpoint (mobile-first approach)
	@media (width <= 575px) {
		.grid-column--col-xs-1 {
			flex: 0 0 8.3333% !important;
			max-width: 8.3333% !important;
			width: 8.3333% !important;
		}

		.grid-column--col-xs-2 {
			flex: 0 0 16.6667% !important;
			max-width: 16.6667% !important;
			width: 16.6667% !important;
		}

		.grid-column--col-xs-3 {
			flex: 0 0 25% !important;
			max-width: 25% !important;
			width: 25% !important;
		}

		.grid-column--col-xs-4 {
			flex: 0 0 33.3333% !important;
			max-width: 33.3333% !important;
			width: 33.3333% !important;
		}

		.grid-column--col-xs-5 {
			flex: 0 0 41.6667% !important;
			max-width: 41.6667% !important;
			width: 41.6667% !important;
		}

		.grid-column--col-xs-6 {
			flex: 0 0 50% !important;
			max-width: 50% !important;
			width: 50% !important;
		}

		.grid-column--col-xs-7 {
			flex: 0 0 58.3333% !important;
			max-width: 58.3333% !important;
			width: 58.3333% !important;
		}

		.grid-column--col-xs-8 {
			flex: 0 0 66.6667% !important;
			max-width: 66.6667% !important;
			width: 66.6667% !important;
		}

		.grid-column--col-xs-9 {
			flex: 0 0 75% !important;
			max-width: 75% !important;
			width: 75% !important;
		}

		.grid-column--col-xs-10 {
			flex: 0 0 83.3333% !important;
			max-width: 83.3333% !important;
			width: 83.3333% !important;
		}

		.grid-column--col-xs-11 {
			flex: 0 0 91.6667% !important;
			max-width: 91.6667% !important;
			width: 91.6667% !important;
		}

		.grid-column--col-xs-12 {
			flex: 0 0 100% !important;
			max-width: 100% !important;
			width: 100% !important;
		}
	}

	// SM breakpoint (576px and up)
	@media (width >= 576px) {
		.grid-column--col-sm-1 {
			flex: 0 0 8.3333% !important;
			max-width: 8.3333% !important;
			width: 8.3333% !important;
		}

		.grid-column--col-sm-2 {
			flex: 0 0 16.6667% !important;
			max-width: 16.6667% !important;
			width: 16.6667% !important;
		}

		.grid-column--col-sm-3 {
			flex: 0 0 25% !important;
			max-width: 25% !important;
			width: 25% !important;
		}

		.grid-column--col-sm-4 {
			flex: 0 0 33.3333% !important;
			max-width: 33.3333% !important;
			width: 33.3333% !important;
		}

		.grid-column--col-sm-5 {
			flex: 0 0 41.6667% !important;
			max-width: 41.6667% !important;
			width: 41.6667% !important;
		}

		.grid-column--col-sm-6 {
			flex: 0 0 50% !important;
			max-width: 50% !important;
			width: 50% !important;
		}

		.grid-column--col-sm-7 {
			flex: 0 0 58.3333% !important;
			max-width: 58.3333% !important;
			width: 58.3333% !important;
		}

		.grid-column--col-sm-8 {
			flex: 0 0 66.6667% !important;
			max-width: 66.6667% !important;
			width: 66.6667% !important;
		}

		.grid-column--col-sm-9 {
			flex: 0 0 75% !important;
			max-width: 75% !important;
			width: 75% !important;
		}

		.grid-column--col-sm-10 {
			flex: 0 0 83.3333% !important;
			max-width: 83.3333% !important;
			width: 83.3333% !important;
		}

		.grid-column--col-sm-11 {
			flex: 0 0 91.6667% !important;
			max-width: 91.6667% !important;
			width: 91.6667% !important;
		}

		.grid-column--col-sm-12 {
			flex: 0 0 100% !important;
			max-width: 100% !important;
			width: 100% !important;
		}
	}

	// MD breakpoint (768px and up)
	@media (width >= 768px) {
		.grid-column--col-md-1 {
			flex: 0 0 8.3333% !important;
			max-width: 8.3333% !important;
			width: 8.3333% !important;
		}

		.grid-column--col-md-2 {
			flex: 0 0 16.6667% !important;
			max-width: 16.6667% !important;
			width: 16.6667% !important;
		}

		.grid-column--col-md-3 {
			flex: 0 0 25% !important;
			max-width: 25% !important;
			width: 25% !important;
		}

		.grid-column--col-md-4 {
			flex: 0 0 33.3333% !important;
			max-width: 33.3333% !important;
			width: 33.3333% !important;
		}

		.grid-column--col-md-5 {
			flex: 0 0 41.6667% !important;
			max-width: 41.6667% !important;
			width: 41.6667% !important;
		}

		.grid-column--col-md-6 {
			flex: 0 0 50% !important;
			max-width: 50% !important;
			width: 50% !important;
		}

		.grid-column--col-md-7 {
			flex: 0 0 58.3333% !important;
			max-width: 58.3333% !important;
			width: 58.3333% !important;
		}

		.grid-column--col-md-8 {
			flex: 0 0 66.6667% !important;
			max-width: 66.6667% !important;
			width: 66.6667% !important;
		}

		.grid-column--col-md-9 {
			flex: 0 0 75% !important;
			max-width: 75% !important;
			width: 75% !important;
		}

		.grid-column--col-md-10 {
			flex: 0 0 83.3333% !important;
			max-width: 83.3333% !important;
			width: 83.3333% !important;
		}

		.grid-column--col-md-11 {
			flex: 0 0 91.6667% !important;
			max-width: 91.6667% !important;
			width: 91.6667% !important;
		}

		.grid-column--col-md-12 {
			flex: 0 0 100% !important;
			max-width: 100% !important;
			width: 100% !important;
		}
	}

	// LG breakpoint (992px and up)
	@media (width >= 992px) {
		.grid-column--col-lg-1 {
			flex: 0 0 8.3333% !important;
			max-width: 8.3333% !important;
			width: 8.3333% !important;
		}

		.grid-column--col-lg-2 {
			flex: 0 0 16.6667% !important;
			max-width: 16.6667% !important;
			width: 16.6667% !important;
		}

		.grid-column--col-lg-3 {
			flex: 0 0 25% !important;
			max-width: 25% !important;
			width: 25% !important;
		}

		.grid-column--col-lg-4 {
			flex: 0 0 33.3333% !important;
			max-width: 33.3333% !important;
			width: 33.3333% !important;
		}

		.grid-column--col-lg-5 {
			flex: 0 0 41.6667% !important;
			max-width: 41.6667% !important;
			width: 41.6667% !important;
		}

		.grid-column--col-lg-6 {
			flex: 0 0 50% !important;
			max-width: 50% !important;
			width: 50% !important;
		}

		.grid-column--col-lg-7 {
			flex: 0 0 58.3333% !important;
			max-width: 58.3333% !important;
			width: 58.3333% !important;
		}

		.grid-column--col-lg-8 {
			flex: 0 0 66.6667% !important;
			max-width: 66.6667% !important;
			width: 66.6667% !important;
		}

		.grid-column--col-lg-9 {
			flex: 0 0 75% !important;
			max-width: 75% !important;
			width: 75% !important;
		}

		.grid-column--col-lg-10 {
			flex: 0 0 83.3333% !important;
			max-width: 83.3333% !important;
			width: 83.3333% !important;
		}

		.grid-column--col-lg-11 {
			flex: 0 0 91.6667% !important;
			max-width: 91.6667% !important;
			width: 91.6667% !important;
		}

		.grid-column--col-lg-12 {
			flex: 0 0 100% !important;
			max-width: 100% !important;
			width: 100% !important;
		}
	}

	// XL breakpoint (1300px and up)
	@media (width >= 1300px) {
		.grid-column--col-xl-1 {
			flex: 0 0 8.3333% !important;
			max-width: 8.3333% !important;
			width: 8.3333% !important;
		}

		.grid-column--col-xl-2 {
			flex: 0 0 16.6667% !important;
			max-width: 16.6667% !important;
			width: 16.6667% !important;
		}

		.grid-column--col-xl-3 {
			flex: 0 0 25% !important;
			max-width: 25% !important;
			width: 25% !important;
		}

		.grid-column--col-xl-4 {
			flex: 0 0 33.3333% !important;
			max-width: 33.3333% !important;
			width: 33.3333% !important;
		}

		.grid-column--col-xl-5 {
			flex: 0 0 41.6667% !important;
			max-width: 41.6667% !important;
			width: 41.6667% !important;
		}

		.grid-column--col-xl-6 {
			flex: 0 0 50% !important;
			max-width: 50% !important;
			width: 50% !important;
		}

		.grid-column--col-xl-7 {
			flex: 0 0 58.3333% !important;
			max-width: 58.3333% !important;
			width: 58.3333% !important;
		}

		.grid-column--col-xl-8 {
			flex: 0 0 66.6667% !important;
			max-width: 66.6667% !important;
			width: 66.6667% !important;
		}

		.grid-column--col-xl-9 {
			flex: 0 0 75% !important;
			max-width: 75% !important;
			width: 75% !important;
		}

		.grid-column--col-xl-10 {
			flex: 0 0 83.3333% !important;
			max-width: 83.3333% !important;
			width: 83.3333% !important;
		}

		.grid-column--col-xl-11 {
			flex: 0 0 91.6667% !important;
			max-width: 91.6667% !important;
			width: 91.6667% !important;
		}

		.grid-column--col-xl-12 {
			flex: 0 0 100% !important;
			max-width: 100% !important;
			width: 100% !important;
		}
	}
</style>
